export enum KeyCodes {
  Enter = 13,
  Space = 32,
  Tab = 9,
}
